module.exports = "<label class=\"custom-select\">\n  <select\n      ng-options=\"option.name for option in $ctrl.options track by option.value\"\n      ng-model=\"$ctrl.model\">\n  </select>\n</label>\n\n\n"


//////////////////
// WEBPACK FOOTER
// ./client/app/common/select-control/select-control.html
// module id = 606
// module chunks = 0